import { render, staticRenderFns } from "./WikiProposalsDialog.vue?vue&type=template&id=fa47d47c&"
import script from "./WikiProposalsDialog.vue?vue&type=script&lang=js&"
export * from "./WikiProposalsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports